export default {
  directorInfo: {
    name: '임관식',
    engNm: 'LIM KWANSIK',
    position: 'Head Coach',
    birthday: '1975년 07월 28일',
    education: '호남대학교',
  },
  playerCareer: [],
  leaderCareer: [
    {
      title: '2026.5~',
      text: '전남드래곤즈 감독'
    }, {
      title: '2025.12~2026.4',
      text: '충남아산 감독'
    }, {
      title: '2023~2024.7',
      text: '안산그리너스 감독'
    }, {
      title: '2023',
      text: '전남드래곤즈 수석코치'
    }, {
      title: '2020~2022',
      text: '김천상무 수석코치'
    }, {
      title: '2015~2016',
      text: '전남드래곤즈 코치'
    }, {
      title: '2013~2014',
      text: '호남대 감독'
    }, {
      title: '2012',
      text: '광주FC 코치'
    }, {
      title: '2010~2011',
      text: '목포시청 코치'
    }
  ],
  leaderAwards: []
};
